import geographyStates from "../../constants/geographyStates";

const states: any = geographyStates;

export const statesItems = Object.entries(states).map((entry: any, index: number) => ({ id: entry[1], title: entry[0], name: entry[0], label: entry[0], value: entry[1] }));
